var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "bright-spot-card"
  }, [_c("section", {
    staticClass: "bright-spot-card-left"
  }, _vm._l(_vm.list.left, function ({
    title,
    desc
  }) {
    return _c("div", {
      key: title,
      staticClass: "item"
    }, [_c("h4", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))])]);
  }), 0), _c("section", {
    staticClass: "bright-spot-card-right"
  }, _vm._l(_vm.list.right, function ({
    title,
    desc
  }) {
    return _c("div", {
      key: title,
      staticClass: "item"
    }, [_c("h4", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))])]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };